<template>
  <v-container>
    <v-snackbar centered timeout="5000" :color="snackbar_color" v-model="snackbar">
      <div class="text-center text-h6">{{ snackbar_text }}</div>
    </v-snackbar>

    <v-card v-if="angemeldet">
      <v-card-title class="primary white--text">Danke für eure Anmeldung!</v-card-title>
      <v-card-text class="text-subtitle-1 pt-4 text-center">
        <div>Wir haben euer Team <strong>{{ data.teamname }}</strong> für das Klopferstockturnier registriert.</div>
        <div class="mt-3">Bitte prüft euer E-Mail-Postfach: Wir haben euch eine Bestätigungs-E-Mail geschickt. Bitte bestätigt darin eure Angaben, damit die Anmeldung gültig wird.</div>
      </v-card-text>
    </v-card>

    <v-card v-else>
      <v-card-title class="primary white--text py-2">Anmeldung Klopferstockturnier</v-card-title>
      <v-card-subtitle class="primary white--text">Meldet euer Team (2 Spieler) an</v-card-subtitle>
      <v-card-text class="pt-4">
        <v-form lazy-validation v-model="form_valid" ref="form">
          <!-- Honeypot-Feld gegen Spam-Bots, für Menschen unsichtbar -->
          <div style="position:absolute; left:-9999px" aria-hidden="true">
            <v-text-field tabindex="-1" autocomplete="off" label="Website" v-model="data.website"></v-text-field>
          </div>

          <v-card class="mt-1">
            <v-card-title class="text-subtitle-1">Team</v-card-title>
            <v-card-text class="pb-0">
              <v-text-field persistent-placeholder :rules="[rules.required]" dense outlined label="Teamname" v-model="data.teamname"></v-text-field>
              <v-text-field persistent-placeholder dense outlined label="Verein" v-model="data.verein"></v-text-field>
              <v-text-field persistent-placeholder :rules="[rules.required, rules.email]" placeholder="team@beispiel.de" dense outlined label="E-Mail" v-model="data.email"></v-text-field>
              <v-text-field persistent-placeholder :rules="[rules.required, rules.telefon]" placeholder="+43 660 1234567" dense outlined label="Telefon" v-model="data.telefon"></v-text-field>
            </v-card-text>
          </v-card>

          <v-card class="mt-3">
            <v-card-title class="text-subtitle-1">Spieler 1</v-card-title>
            <v-card-text class="pb-0">
              <v-text-field persistent-placeholder :rules="[rules.required]" dense outlined label="Vorname" v-model="data.spieler1_vorname"></v-text-field>
              <v-text-field persistent-placeholder :rules="[rules.required]" dense outlined label="Nachname" v-model="data.spieler1_nachname"></v-text-field>
            </v-card-text>
          </v-card>

          <v-card class="mt-3">
            <v-card-title class="text-subtitle-1">Spieler 2</v-card-title>
            <v-card-text class="pb-0">
              <v-text-field persistent-placeholder :rules="[rules.required]" dense outlined label="Vorname" v-model="data.spieler2_vorname"></v-text-field>
              <v-text-field persistent-placeholder :rules="[rules.required]" dense outlined label="Nachname" v-model="data.spieler2_nachname"></v-text-field>
            </v-card-text>
          </v-card>

          <v-textarea class="mt-3" persistent-placeholder dense outlined label="Anmerkung" v-model="data.anmerkung"></v-textarea>

          <v-checkbox
            class="mt-0"
            :rules="[rules.required]"
            v-model="data.datenschutz_akzeptiert"
            label="Ich bin damit einverstanden, dass meine Daten zur Durchführung des Turniers gespeichert werden."
          ></v-checkbox>
        </v-form>
      </v-card-text>
      <v-card-actions class="pt-0">
        <div class="d-block flex-grow-1">
          <div>
            <v-btn :disabled="!anmeldenOK" color="primary" @click="anmelden" block>Team anmelden
              <v-icon right dark>mdi-content-save</v-icon>
            </v-btn>
          </div>
        </div>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>

import axios from 'axios';

export default {
  name: 'Klopferstock-Anmeldung',
  data: () => ({
    api: "",
    angemeldet: false,
    snackbar_color: "green",
    snackbar_text: "",
    snackbar: false,
    form_valid: false,
    data: {
      teamname: "",
      verein: "",
      email: "",
      telefon: "",
      spieler1_vorname: "",
      spieler1_nachname: "",
      spieler2_vorname: "",
      spieler2_nachname: "",
      anmerkung: "",
      datenschutz_akzeptiert: false,
      website: "",
    },
    rules: {
      required: value => !!value || 'Angabe erforderlich.',
      email: value => /.+@.+\..+/.test(value) || 'Bitte eine gültige E-Mail-Adresse eingeben',
      telefon: value => /^\+?[0-9\s]{6,20}$/.test(value) || 'Bitte Telefonnummer im Format "+43 660 1234567" eingeben',
    },
  }),
  mounted(){
    this.api = process.env.VUE_APP_APIURL
  },
  methods:{
    validate(){
      if (this.$refs && this.$refs.form) return this.$refs.form.validate()
      return false
    },
    anmelden(){
      if (!this.validate()) return
      axios.post(this.api+'klopferstock/anmelden/', this.data)
        .then((resp) => {
          if (resp.data.success){
            this.angemeldet = true
          }else{
            this.snackbar_color = "red"
            this.snackbar_text = "FEHLER beim Speichern"
            this.snackbar = true
          }
        })
        .catch((err) => {
          const errors = err.response && err.response.data && err.response.data.errors
          this.snackbar_color = "red"
          this.snackbar_text = errors ? Object.values(errors).join(", ") : "FEHLER beim Speichern"
          this.snackbar = true
        })
    },
  },
  computed:{
    anmeldenOK: function(){
      return this.form_valid && !!this.data.datenschutz_akzeptiert
    },
  },
}
</script>
